import { User } from 'domain/User'

export enum UserRole {
  admin = 'admin',
  member = 'member',
  manager = 'manager',
  billing = 'billing',
  purchaseOrderOperator = 'purchaseOrderOperator',
}

// Needed for Ops that are logging in as a user
export enum OpsUserRole {
  purchaseOrderOperator = 'purchaseOrderOperator',
  purchaseOrderImplementationManager = 'purchaseOrderImplementationManager',
}

export type Role = UserRole | OpsUserRole

export const USER_ROLE_ADMIN = UserRole.admin
export const USER_ROLE_MEMBER = UserRole.member
export const USER_ROLE_MANAGER = UserRole.manager
export const USER_ROLE_BILLING = UserRole.billing

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
export const UserRoles: UserRole[] = Object.keys(UserRole).map((key: any) => UserRole[key] as UserRole)

export const hasRoles = (user: User, roles: Role[]): boolean => {
  return roles.some((role) => (user.roles || []).indexOf(role) !== -1)
}

const managerRoles = [UserRole.admin, UserRole.manager]
const memberRoles = [...managerRoles, UserRole.member]

export const authorize = {
  admins: [UserRole.admin],
  managers: [...managerRoles],
  membersOrBilling: [...memberRoles, UserRole.billing],
  membersOrSupplier: [...memberRoles],
  purchaseOrderOperators: [OpsUserRole.purchaseOrderOperator],
  all: UserRoles,
}
